import * as categoryStyles from '../../../styles/events/event-page.module.scss';
import { PropTypes } from 'prop-types';
import React from 'react';
import clsx from 'clsx';

const Category = ({
  clicked,
  label,
  variant,
  disabled,
  basecolor,
  handleClick,
  clickOff,
  ariaLabel,
  ariaDescribedBy,
  lang,
  notFocusable,
  underline,
  disablePointer,
  maxWidth,
  noMargin,
  padding,
}) => {
  const grey = 'var(--light-grey-color)';
  const red = 'var(--red-color)';
  const white = 'var(--white-color)';

  const getColor = React.useCallback((basecolor) => {
    switch (variant) {
    case 'contained':
      return clicked ? basecolor : white;
    case 'color':
      return clicked ? white : basecolor;
    case 'light':
      return clicked ? basecolor : grey;
    default:
      return clicked ? white : basecolor;
    }
  }, [clicked, grey, white, variant]);

  const getBackgroundColor = React.useCallback((basecolor) => {
    switch (variant) {
    case 'contained':
      return clicked ? white : basecolor;
    case 'color':
      return clicked ? basecolor : white;
    case 'light':
      return white;
    default:
      return clicked ? basecolor : white;
    }
  }, [clicked, white, variant]);

  const color = getColor(basecolor ? basecolor : red);
  const backgroundColor = getBackgroundColor(basecolor ? basecolor : red);

  const conditionalAttrLink = {};

  if (underline) {
    conditionalAttrLink['aria-pressed'] = true;
  }

  return (
    <button
      {...conditionalAttrLink}
      aria-describedby={ariaDescribedBy}
      aria-label={ariaLabel}
      className={clsx(categoryStyles.actuChip, {[categoryStyles.chipHover]: !clickOff})}
      disabled={disabled}
      lang={lang}
      onClick={(e) => {
        if (!disabled && handleClick) handleClick(e);
      }}
      style={{
        maxWidth: maxWidth ? maxWidth : undefined,
        padding: padding ? padding : undefined,
        margin: noMargin ? 0 : undefined,
        border: `1px solid ${color}`,
        color: color,
        backgroundColor: backgroundColor, ...disablePointer,
        textDecoration: underline ? 'underline' : undefined,
        textUnderlinePosition: underline ? 'under' : undefined,
      }}
      tabIndex={notFocusable ? -1 : 0}
    >
      {label}
    </button>
  );
};

Category.propTypes = {
  ariaDescribedBy: PropTypes.string,
  ariaLabel: PropTypes.string,
  basecolor: PropTypes.string,
  clickOff: PropTypes.bool,
  clicked: PropTypes.bool,
  disablePointer: PropTypes.object,
  disabled: PropTypes.bool,
  handleClick: PropTypes.func,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  lang: PropTypes.string,
  maxWidth: PropTypes.string,
  noMargin: PropTypes.bool,
  notFocusable: PropTypes.bool,
  padding: PropTypes.string,
  underline: PropTypes.bool,
  variant: PropTypes.string,
};

export default Category;
